import * as React from 'react';
import { PoiLayerTogglePanel } from './poi-layer-toggle-panel';

interface PoiLayerOverlayProps {
  visibleCategories: Set<string>;
  onVisibleCategoriesChange: (visibleCategories: Set<string>) => void;
  /** Transport layer integration — optional, renders transport section inside toggle panel */
  transportPublicEnabled?: boolean;
  onTransportPublicToggle?: () => void;
  roadsEnabled?: boolean;
  onRoadsToggle?: () => void;
  /** Show zoom hint under public transport toggle when zoom is below city threshold */
  showTransportZoomHint?: boolean;
  /** Show zoom hint under roads toggle when zoom is below road threshold */
  showRoadsZoomHint?: boolean;
  /** Show loading spinner in transport section header while bbox fetch is in-flight */
  isTransportLoading?: boolean;
  /** Show empty hint in transport section when layer is on but response has no features */
  isTransportEmpty?: boolean;
  /** Administrative-area layer integration — optional, renders its own section inside toggle panel */
  adminAreaEnabled?: boolean;
  onAdminAreaToggle?: () => void;
  /** Show loading spinner next to the administrative-area toggle while bbox fetch is in-flight */
  isAdminAreaLoading?: boolean;
  /** Show a recoverable error hint when the administrative-area geometry request failed */
  isAdminAreaError?: boolean;
}

export function PoiLayerOverlay({
  visibleCategories,
  onVisibleCategoriesChange,
  transportPublicEnabled,
  onTransportPublicToggle,
  roadsEnabled,
  onRoadsToggle,
  showTransportZoomHint,
  showRoadsZoomHint,
  isTransportLoading,
  isTransportEmpty,
  adminAreaEnabled,
  onAdminAreaToggle,
  isAdminAreaLoading,
  isAdminAreaError,
}: PoiLayerOverlayProps) {
  return (
    <div className="absolute top-4 right-4 z-20 flex flex-col items-end gap-2">
      <PoiLayerTogglePanel
        visibleCategories={visibleCategories}
        onVisibleCategoriesChange={onVisibleCategoriesChange}
        transportPublicEnabled={transportPublicEnabled}
        onTransportPublicToggle={onTransportPublicToggle}
        roadsEnabled={roadsEnabled}
        onRoadsToggle={onRoadsToggle}
        showTransportZoomHint={showTransportZoomHint}
        showRoadsZoomHint={showRoadsZoomHint}
        isTransportLoading={isTransportLoading}
        isTransportEmpty={isTransportEmpty}
        adminAreaEnabled={adminAreaEnabled}
        onAdminAreaToggle={onAdminAreaToggle}
        isAdminAreaLoading={isAdminAreaLoading}
        isAdminAreaError={isAdminAreaError}
      />
    </div>
  );
}
